export const AUTH_TOKEN_HEADER_KEY = 'Authorization';
export const AUTH_TOKEN_PREFIX = 'Bearer ';
export const AUTH_TOKEN_SKIP = 'Skip-Token';
export const AUTH_TOKEN_SKIP_REFRESH = 'Skip-Token-Refresh';

export const IGNORE_PROGRESS_BAR = 'ignoreProgressBar';
